import { useDownloadS3SignedUrl } from '@/context/services/downloads/index.service';
import { usePaymentDetail } from '@/components/InvoiceReportDetailDrawer/context/PaymentDetailContext';
import { useDownloadClick } from '@/features/invoices/components/Details/Components/Left/hooks';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { useCallback, useState } from 'react';

export const useDocumentMenuActions = (isEmpty?: boolean) => {
  const container = useGlobalContainerRef();
  const { pdfViewerProps } = usePaymentDetail();
  const [open, setOpen] = useState(false);
  const [showMetadata, setShowMetadata] = useState(false);

  const pdfUrl = pdfViewerProps?.pdfUrl || '';
  const fileName = pdfViewerProps?.title || 'invoice.pdf';

  const { data: downloadData } = useDownloadS3SignedUrl(pdfUrl, {
    query: { enabled: !!pdfUrl },
  });

  const handleDownload = useDownloadClick(
    downloadData?.data || new Blob(),
    fileName
  );

  const onClick = useCallback(() => {
    if (!isEmpty) {
      setOpen((prev) => !prev);
    }
  }, [isEmpty]);

  const onClose = useCallback(() => {
    setOpen(false);
    setShowMetadata(false);
  }, []);

  const handleCloseMetadata = useCallback(() => {
    setShowMetadata(false);
  }, []);

  const handleOpenMetadata = useCallback(() => {
    setShowMetadata(true);
  }, []);

  return {
    open,
    showMetadata,
    container,
    handleDownload,
    onClick,
    onClose,
    handleCloseMetadata,
    handleOpenMetadata,
  };
};
